import { Desktop, Mobile } from '../../../../App';
import StructureDesktop from './desktop/StructureDesktop';
import StructureMobile from './mobile/StructureMobile';
import AddNewMemberModal from '../../common/AddNewMemberModal/AddNewMemberModal';

export const TradingStructure = ({ selectTab }) => {
  return (
    <>
      <Desktop>
        <StructureDesktop selectTab={selectTab} />
      </Desktop>
      <Mobile>
        <StructureMobile selectTab={selectTab} />
      </Mobile>
      <AddNewMemberModal />
    </>
  );
};
